import { gettingStarted } from './privateCloudBusinessEditionFieldConfig';
export const pagesConfig = [...gettingStarted()];
